<ul class="nav nav-tabs">
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
    <a href="javascript:void(0);">{{tab.tabTitle}}</a>
  </li>
</ul>
<ng-content></ng-content>
